import { Light } from "@/models";

export const types = {
    SET_INIT_HISTORY: "map/global/set-init-history",
    UNDO: "map/global/undo",
    REDO: "map/global/redo",
    SET_LIGHTS: "map/global/set-lights",
    UPDATE_LIGHTS: "map/global/update-lights",
    UPDATE_LIGHTS_SILENT: "map/global/update-lights-silent",
    DELETE_LIGHTS: "map/global/delete-lights",
    UPDATE_DELETE_LIGHTS: "map/global/update-delete-lights",
    CLEAR_DELETED_LIGHTS: "map/global/clear-deleted-lights",
    ADD_GROUP_GEOMETRY: "map/global/add-group-geometry",
    DELETE_GROUP_GEOMETRY: "map/global/delete-group-geometry",
    SET_GROUP_GEOMETRIES: "map/global/set-group-geometries",
    SET_MARKERS: "map/global/set-markers",
    UPDATE_MARKERS: "map/global/update-markers",
    DELETE_MARKERS: "map/global/delete-markers",
    CLEAR_DELETED_MARKERS: "map/global/clear-deleted-markers",
};

export default {
    redo: () => ({ type: types.REDO }),
    undo: () => ({ type: types.UNDO }),
    clearDeletedLights: () => ({
        type: types.CLEAR_DELETED_LIGHTS,
    }),
    setInitHistory: () => ({
        type: types.SET_INIT_HISTORY,
    }),
    updateDeleteLights: (deletedLights) => ({
        type: types.UPDATE_DELETE_LIGHTS,
        payload: deletedLights,
    }),
    deleteLights: (deletedLights = []) => ({
        type: types.DELETE_LIGHTS,
        payload: deletedLights,
    }),
    setLights: (lights, reset = true) => ({
        type: types.SET_LIGHTS,
        payload: {
            lights: Light.reduceLights(lights),
            reset,
        },
    }),
    updateLights: (lights) => ({
        type: types.UPDATE_LIGHTS,
        payload: Light.reduceLights(lights),
    }),
    updateLightsSilent: (lights) => ({
        type: types.UPDATE_LIGHTS_SILENT,
        payload: Light.reduceLights(lights),
    }),
    addGroupGeometry: (geometry) => ({
        type: types.ADD_GROUP_GEOMETRY,
        payload: geometry,
    }),
    deleteGroupGeometry: (geometryId) => ({
        type: types.DELETE_GROUP_GEOMETRY,
        payload: geometryId,
    }),
    setGroupGeometries: (geometries) => ({
        type: types.SET_GROUP_GEOMETRIES,
        payload: geometries,
    }),
    setMarkers: (markers) => ({
        type: types.SET_MARKERS,
        payload: markers,
    }),
    updateMarkers: (markers) => ({
        type: types.UPDATE_MARKERS,
        payload: markers,
    }),
    deleteMarkers: (markers) => ({
        type: types.DELETE_MARKERS,
        payload: markers,
    }),
    clearDeletedMarkers: () => ({
        type: types.CLEAR_DELETED_MARKERS,
    }),
};
